import React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import { styled } from '@mui/system';

import { CHILDREN_PROP_TYPES } from 'propTypes';
import { BUTTON_COMPONENT_PROPTYPES } from 'bento-ordering/base/constants/propTypes';
import muiPropForwarding from 'styles/helpers/muiPropForwarding';
import {
  getButtonFontHoverColor,
  getHeaderAndNavigationTypography
} from 'styles/helpers/getThemeStyles';

const PrimaryCtaButton = styled(Button, {
  shouldForwardProp: muiPropForwarding('ownState')
})(({ theme, ownState }) => {
  const ownButtonStyles = ownState?.button?.(theme) ?? {};
  const fontStyles = getHeaderAndNavigationTypography(theme);

  return {
    '&.MuiButton-containedPrimary': {
      backgroundColor: theme.palette.button.background.main,
      color: theme.palette.button.font.main,
      transition: 'color 250ms cubic-bezier(0.4, 0, 0.2, 1)',
      ...fontStyles,
      ...ownButtonStyles,
      '&:hover': {
        backgroundColor: theme.palette.button.background.hover,
        color: getButtonFontHoverColor(theme)
      }
    },
    '&.Mui-disabled': {
      '&&': {
        color: theme.palette?.button?.font.main,
        opacity: 0.5
      }
    }
  };
});

const PrimaryCta = ({
  handleClick,
  label,
  to,
  href,
  fullWidth,
  className,
  disabled,
  component,
  type,
  id,
  dataTestId,
  ownState,
  startIcon = null,
  allowPreview = false
}) => {
  return (
    <PrimaryCtaButton
      fullWidth={fullWidth}
      component={component}
      variant="contained"
      onClick={handleClick}
      to={to}
      href={href}
      className={className}
      disabled={disabled}
      type={type}
      id={id}
      data-testid={dataTestId}
      ownState={ownState}
      startIcon={startIcon}
      data-allow-preview={allowPreview}
    >
      {label}
    </PrimaryCtaButton>
  );
};

PrimaryCta.defaultProps = {
  onClick: () => {},
  fullWidth: false,
  type: 'button',
  ownState: {}
};

PrimaryCta.propTypes = {
  handleClick: PropTypes.func,
  label: CHILDREN_PROP_TYPES,
  to: PropTypes.string,
  href: PropTypes.string,
  fullWidth: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  component: BUTTON_COMPONENT_PROPTYPES,
  type: PropTypes.string,
  id: PropTypes.string,
  dataTestId: PropTypes.string,
  ownState: PropTypes.object,
  startIcon: PropTypes.element,
  allowPreview: PropTypes.bool
};

export default PrimaryCta;
